import React from 'react';

import { QRCodeSVG } from 'qrcode.react';

import { CopyToClipboard, CustomLink } from '../../../../../components';
import config from '../../../../../configs/app';
import {
  useEffectOnMount,
  useNavigateByName,
  useProfileData,
  useUserCode,
} from '../../../../../hooks';
import { RouteDictionary } from '../../../../../utils';
import styles from './Deposit.module.scss';

const Deposit = () => {
  const profileData = useProfileData();
  const navigate = useNavigateByName();
  const userCode = useUserCode();

  const requisites = [
    { label: 'Номер счета', value: config.depositAccount },
    { label: 'Банк', value: config.depositBank },
    { label: 'БИК', value: config.depositBIC },
    { label: 'ИНН', value: config.depositINN },
    { label: 'КПП', value: config.depositKPP },
    { label: 'Наименование получателя', value: config.depositName },
    { label: 'Корр. счет', value: config.correspAcc },
  ];

  const purpose = `Пополнение счёта, согласно Агентскому договору № ${profileData.paymentCode}, НДС 0`;
  const purposeText = `Пополнение счёта, согласно Агентскому договору № ${userCode}, НДС 0`;

  const getQrCodeString = () => {
    return (
      `ST00012|Name=${config.depositName}` +
      `|BIC=${config.depositBIC}` +
      `|PersonalAcc=${config.depositAccount}` +
      `|BankName=${config.depositBank}` +
      `|PayeeINN=${config.depositINN}` +
      `|KPP=${config.depositKPP}` +
      `|Purpose=${purpose}` +
      `|CorrespAcc=${config.correspAcc}`
    );
  };

  const canDeposit = () => {
    return profileData.lenderVerified && profileData.agentCode !== null;
  };

  useEffectOnMount(() => {
    if (!canDeposit()) {
      navigate(RouteDictionary.MY_MONEY);
    }
  });

  return (
    <div className={styles.deposit}>
      <nav className={styles.breadcrumbs}>
        <CustomLink to={RouteDictionary.MY_MONEY} className={styles.breadcrumbLink}>
          Главная
        </CustomLink>
        <span className={styles.breadcrumbSeparator}>/</span>
        <span className={styles.breadcrumbCurrent}>Пополнение</span>
      </nav>

      <div className={styles.grid}>
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Пополнение через реквизиты</h2>

          <div className={styles.requisites}>
            {requisites.map((item) => (
              <div className={styles.requisite} key={item.label}>
                <span className={styles.label}>{item.label}</span>
                <div className={styles.valueGroup}>
                  <span className={styles.value}>{item.value}</span>
                  <CopyToClipboard textToCopy={item.value} />
                </div>
              </div>
            ))}
          </div>

          <div className={styles.purpose}>
            <span className={styles.label}>Назначение платежа</span>
            <div className={styles.valueGroup}>
              <span className={styles.purposeText}>{purposeText}</span>
              <CopyToClipboard textToCopy={userCode} />
            </div>
          </div>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Пополнение через QR-код</h2>

          <div className={styles.qrBox}>
            <span className={styles.qrHint}>Отсканируйте QR-код, чтобы пополнить счет</span>
            <div className={styles.qrCode}>
              <QRCodeSVG size={240} level="L" value={getQrCodeString()} />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Deposit;
